import React, { useState } from 'react';
import { SvgDownload, ChevronDownIcon } from '../../../components/icons';
import { TranscriptExportProps } from '../../../types/transcript';

export default function TranscriptExport({
    onExport,
    formats,
    disabled = false
}: TranscriptExportProps) {
    const [isOpen, setIsOpen] = useState(false);

    const handleExport = (format: string) => {
        onExport(format);
        setIsOpen(false);
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                disabled={disabled}
                className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md border transition-colors ${
                    disabled
                        ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                }`}
            >
                <SvgDownload className="h-4 w-4" />
                Export
                <ChevronDownIcon className="h-4 w-4" />
            </button>

            {isOpen && !disabled && (
                <>
                    <div 
                        className="fixed inset-0 z-10" 
                        onClick={() => setIsOpen(false)}
                    />
                    <div className="absolute right-0 top-full mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-20">
                        <div className="py-1">
                            {formats.map((format) => (
                                <button
                                    key={format}
                                    onClick={() => handleExport(format)}
                                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                                >
                                    <span className="flex-1">Export as {format}</span>
                                    <span className="text-xs text-gray-500">
                                        {format === 'TXT' && 'Plain text'}
                                        {format === 'JSON' && 'Structured data'}
                                        {format === 'SRT' && 'Subtitle file'}
                                        {format === 'PDF' && 'Document'}
                                    </span>
                                </button>
                            ))}
                        </div>
                        
                        <div className="border-t border-gray-200 px-4 py-2">
                            <p className="text-xs text-gray-500">
                                Choose a format to download the transcript
                            </p>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}